import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
import {Col} from "reactstrap";
const style = {
    height: '12rem',
    width: '12rem',
    marginRight: '1.5rem',
    marginBottom: '1.5rem',
    color: 'white',
    padding: '1rem',
    textAlign: 'center',
    fontSize: '1rem',
    lineHeight: 'normal',
    float: 'left',
};
const TIMELINE_ITEM_TYPE = 'TIMELINE_ITEM';

const TimelineItem = ({ entry, index, onMove, onRemove }) => {
    const ref = React.useRef(null);
    const [, drop] = useDrop({
        accept: TIMELINE_ITEM_TYPE,
        hover(item) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) {
                return;
            }
            onMove(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        item: { type: TIMELINE_ITEM_TYPE, index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    drag(drop(ref));

    return (
        <div
            ref={ref}
            className="time-line-img-child"
            style={{ opacity: isDragging ? 0.5 : 1, cursor: 'move' }}
        >
            <div className="d-flex align-items-center justify-content-between">
                <span>{entry.file_name} ({parseInt(entry.duration, 10) || 0}s)</span>
                <span>
                    <button
                        type="button"
                        className="btn btn-link btn-sm p-0 text-danger"
                        onClick={() => onRemove(index)}
                        title="Remove"
                    >
                        <i className="mdi mdi-close-circle"></i>
                    </button>
                </span>
            </div>
        </div>
    );
};

export const Dustbin = (props) => {
    const [{ canDrop, isOver, didDrop }, drop] = useDrop({
        accept: ItemTypes.BOX,
        drop: () => ({ name: 'Dustbin' }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            didDrop: monitor.didDrop()
        }),
    });
    const isActive = canDrop && isOver;
    let backgroundColor = '#FAFAFA';
    if (isActive) {
        backgroundColor = 'darkgreen';
    }
    else if (canDrop) {
        backgroundColor = 'darkkhaki';
    }
    return (
        <div className="media-body p-0" id="time-line-append" ref={drop} style={{ backgroundColor }}>
            {props.items && props.items.map((entry, index) => (
                <TimelineItem
                    key={`${entry.id}-${index}`}
                    entry={entry}
                    index={index}
                    onMove={props.onMove}
                    onRemove={props.onRemove}
                />
            ))}
        </div>
    )
};
